if(!customElements.get('media-gallery')){
    class MediaGallery extends HTMLElement {
        constructor(){
            super();

            this.columnType = this.dataset.columnType;
            this.parent = this.closest('.section-gallery');
            this.galleryItems = this.querySelectorAll('.gallery-item');
            this.videos = this.querySelectorAll('video');

            if(this.columnType === 'slideshow'){
                this.initializeSwiper();
            }

           
        }

        connectedCallback(){
            this.videos.forEach(video => {
                if(typeof video === 'undefined') return;
                video.addEventListener("loadeddata", e => {
                    video.classList.add('loaded');
                });

                if(video.readyState >= 2){
                    video.classList.add('loaded');
                }
            });

            this.galleryItems.forEach(item => {
                item.addEventListener("click", this.openGalleryPopup.bind(this));
                item.addEventListener("keydown", e => {
                    if(e.code === 'Enter') this.openGalleryPopup(e);
                })
            });
        }
        openGalleryPopup(e){
            if(!parent) return;
            this.popup = this.parent.querySelector('gallery-popup');

            const currentTarget = e.currentTarget;
            const currentIndex = parseInt(currentTarget?.dataset.index);
            if(typeof currentIndex === 'number'){
                this.popup.currentIndex = parseInt(currentIndex) - 1;
            }
            this.popup.open();
        }

        async initializeSwiper(){
            this.swiperContainer = this.querySelector('.swiper-container');
            if(!this.swiperContainer) return;

            this.slides = this.querySelectorAll('.swiper-slide');
            if(this.slides.length <= 1) return;

            if(typeof Swiper === 'undefined'){
                await new Promise(resolve => {
                    const check = () => {
                        if(typeof Swiper !== 'undefined') resolve();
                        else requestAnimationFrame(check);
                    };
                    check();
                });
            }

            const itemsPerView = parseInt(this.swiperContainer.dataset.itemsPerView);
            const itemsPerViewMobile = parseInt(this.swiperContainer.dataset.itemsPerViewMobile);
            const totalSlides = parseInt(this.swiperContainer.dataset.itemsTotal);
            const autoplay = this.swiperContainer.dataset.autoplay === 'true';
            const speed = parseInt(this.swiperContainer.dataset.speed);
            const loop = this.swiperContainer.dataset.loop === 'true';
            const visibleItemsPerView = (itemsPerView && totalSlides > itemsPerView)? itemsPerView : totalSlides;
            const spaceBetween = parseInt(this.swiperContainer.dataset.gap);

            const breakpoints = {
                0: { slidesPerView: itemsPerViewMobile },
                768: { slidesPerView: visibleItemsPerView }
            }

            var swiperSettings = {
                init: false,
                initialSlide: 0,
                loop: loop,
                centeredSlides: false,
                speed: 500,
                watchOverflow: true,
                breakpoints: breakpoints,
                observer: true,
                observeSlideChildren: true,
                watchSlidesProgress: true,
                autoHeight: false,
                spaceBetween: spaceBetween,
                 on: {
                    init: () => {
                        const paginationBullets = this.querySelectorAll(".swiper-pagination-bullet");
                        if(paginationBullets.length > 0){
                            this.style.setProperty('--pagination-width', `calc(100% / ${paginationBullets.length})`);
                            paginationBullets.forEach((item, index) => {
                                item.setAttribute('data-index', `${index}`);
                            });
                            setTimeout(() => {
                                this.querySelector('.swiper-pagination')?.classList.add('loaded');
                                this.checkSwiperLock();
                            }, 500);
                        }
                    },
                    slideChange: () => {
                        const activePagination = this.querySelector(".swiper-pagination-bullet-active");
                        if(activePagination){
                            const activePaginationIndex = parseInt(activePagination.dataset.index);
                            this.style.setProperty('--pagination-translate-x', `calc(100% * ${activePaginationIndex})`);
                        }
                    }
                }
            }

            if(this.swiperContainer.querySelector(".swiper-navigation-wrapper")){
                swiperSettings.navigation = {
                    nextEl: this.swiperContainer?.querySelector('.button-next'),
                    prevEl: this.swiperContainer?.querySelector('.button-previous')
                }
            }

            if(this.querySelector('.swiper-pagination')){
                swiperSettings.pagination = {
                    el: this.querySelector('.swiper-pagination')
                }
            }

            if(autoplay && !isNaN(speed)){
                swiperSettings.autoplay = {
                    delay: speed
                }
            }

            this.swiper = new Swiper(this.swiperContainer, swiperSettings);
            this.swiper.init();

            this.swiper.on("resize", this.checkSwiperLock.bind(this));

            this.setupFocusListeners();
        }

        checkSwiperLock(){
            if(!this.querySelector(".swiper-pagination")) return;
            
            if(this.swiper.isLocked){
                this.querySelector(".swiper-pagination").classList.add('hidden');
            }else{
                this.querySelector(".swiper-pagination").classList.remove('hidden');
            }
        }

        setupFocusListeners(){
            this.querySelectorAll(".button-next, .button-previous").forEach(button => {
                button.addEventListener('focus', () => {
                    button.classList.add('focused');
                    button.addEventListener('blur', () => {
                        button.classList.remove('focused');
                    }, { once: true });
                });
            });
        }
    }

    customElements.define('media-gallery', MediaGallery);
}